import './recoveryDetect'; // must stay the FIRST import: records whether the page was opened from a password-reset e-mail link
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PasswordRecoveryGate from './components/PasswordRecoveryGate';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PasswordRecoveryGate>
      <App />
    </PasswordRecoveryGate>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
